<template>
  <CSidebar
      class="bg-style1"
      :minimize="minimize"
      unfoldable
      :show="show"
      @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" >
<!--      <CIcon-->
<!--          class="c-sidebar-brand-full"-->
<!--          name="logo"-->
<!--          size="custom-size"-->
<!--          :height="35"-->
<!--          viewBox="0 0 556 134"-->
<!--      />-->
      <div class="c-sidebar-brand-full" >
        <a href="/">
          <CRow >
            <img class="pt-2 pb-2" src="@/assets/mfu_logo.png" height="60px">
            <CCol class="text-white">
              <p class="font-weight-bold mb-0 mt-2 h5">MFU</p>
              <p class="font-weight-bold">Dashboard System</p>
            </CCol>
          </CRow>
        </a>

      </div>


      <!--      <img src="@/assets/logo.svg" height="48"/>-->
      <img class="c-sidebar-brand-minimized" src="@/assets/mfu_logo.png" height="35px" alt="MFU logo">
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="navs"/>
    <CSidebarMinimizer
        class="c-d-md-down-none"
        @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import {
  detectRouteRole,
  getAssignedRoles,
  getWorkspaceNavigation,
  getWorkspaceRole,
  filterNavigationByPermissions,
  workspaceRoleEventName
} from '@/utils/role-dashboard'
import Service from '@/service/api'
import { canAutoRefresh } from '@/projects/utils/refresh-guard'
import { readWorkspacePreferences, saveWorkspacePreferences } from '@/utils/workspace-preferences'
import { workflowNotificationEventName } from '@/utils/workflow-notifications'

function resolveAccountId(profile) {
  if (!profile || typeof profile !== 'object') return ''
  return String(
    profile._id ||
    profile.id ||
    (profile.accounts && profile.accounts._id) ||
    (Array.isArray(profile.accounts) && profile.accounts[0] && (profile.accounts[0]._id || profile.accounts[0].id)) ||
    ''
  ).trim()
}

export default {
  name: 'TheSidebar',
  data() {
    return {
      countsLoading: false,
      lastSidebarCountsAt: 0,
      navCounts: {
        adminReviewQueue: 0,
        adminTranslationQueue: 0,
        committeeReviewQueue: 0,
        userReviewQueue: 0,
        userTranslationQueue: 0
      },
      workspaceRoleVersion: 0
    }
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    navs() {
      const navigation = getWorkspaceNavigation(this.workspaceRole, this.assignedRoles, this.navCounts)
      if (this.workspaceRole === 'admin' || this.workspaceRole === 'multiuser') {
        return navigation
      }

      const securityState = this.$store.state.security || {}
      const matrix = securityState.matrix && typeof securityState.matrix === 'object' ? securityState.matrix : {}
      const hasPermissionMatrix = Object.keys(matrix).length > 0

      if (!securityState.loaded || !hasPermissionMatrix) {
        return navigation
      }

      return filterNavigationByPermissions(navigation, this.$store.getters['security/canAccess'])
    },
    menuCatalog() {
      return this.$store.getters['security/catalogMenus'] || []
    },
    workspaceRole() {
      this.workspaceRoleVersion
      if (this.assignedRoles.length > 1) {
        return 'multiuser'
      }
      const baseWorkspaceRole = getWorkspaceRole(this.$store)
      if (baseWorkspaceRole === 'multiuser') {
        return 'multiuser'
      }
      const routeRole = detectRouteRole(this.$store, this.$route)
      return routeRole || baseWorkspaceRole
    },
    assignedRoles() {
      return getAssignedRoles(this.$store)
    },
    profile() {
      return this.$store.getters['auth/profile'] || null
    }
  },
  watch: {
    assignedRoles: {
      immediate: true,
      handler() {
        this.loadSidebarCounts({ force: true })
      }
    },
    profile: {
      immediate: true,
      handler() {
        this.loadPermissions({ force: true })
      }
    },
    minimize(value) {
      const preferences = readWorkspacePreferences()
      if (!preferences.rememberSidebar) return
      saveWorkspacePreferences({
        ...preferences,
        startMinimizedSidebar: !!value
      })
    }
  },
  mounted() {
    window.addEventListener('focus', this.handleWindowFocus)
    window.addEventListener(workflowNotificationEventName(), this.handleWorkflowNotificationChange)
    window.addEventListener(workspaceRoleEventName(), this.handleWorkspaceRoleChange)
    this.refreshTimer = window.setInterval(() => {
      if (canAutoRefresh()) this.loadSidebarCounts()
    }, 180000)
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.handleWindowFocus)
    window.removeEventListener(workflowNotificationEventName(), this.handleWorkflowNotificationChange)
    window.removeEventListener(workspaceRoleEventName(), this.handleWorkspaceRoleChange)
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    handleWorkspaceRoleChange() {
      this.workspaceRoleVersion += 1
      this.lastSidebarCountsAt = 0
      this.loadSidebarCounts({ force: true })
    },
    handleWorkflowNotificationChange() {
      this.lastSidebarCountsAt = 0
      this.loadSidebarCounts({ force: true })
    },
    handleWindowFocus() {
      this.loadSidebarCounts()
      this.loadPermissions()
    },
    async loadPermissions(options = {}) {
      try {
        const accountId = resolveAccountId(this.profile)
        if (!accountId) return
        await Promise.all([
          this.$store.dispatch('security/fetchNavigationCatalog', {
            force: !!options.force,
            cacheMaxAge: 300000
          }),
          this.$store.dispatch('security/fetchMyPermissions', {
          accountId,
          force: !!options.force,
          cacheMaxAge: 60000
          })
        ])
      } catch (error) {
        // Keep the sidebar stable if permission lookup fails.
      }
    },
    async loadSidebarCounts(options = {}) {
      try {
        const cacheMaxAge = typeof options.cacheMaxAge === 'number' ? options.cacheMaxAge : 180000
        if (this.countsLoading) return
        if (!options.force && this.lastSidebarCountsAt && (Date.now() - this.lastSidebarCountsAt) < cacheMaxAge) {
          return
        }

        this.countsLoading = true
        const nextCounts = {
          adminReviewQueue: 0,
          adminTranslationQueue: 0,
          committeeReviewQueue: 0,
          userReviewQueue: 0,
          userTranslationQueue: 0
        }

        const tasks = []

        if (this.assignedRoles.includes('admin')) {
          tasks.push(
            Promise.allSettled([
              Service.adminReview('queue'),
              Service.translation('requests', {}, { forceRefresh: !!options.force })
            ]).then(([reviewsRes, translationsRes]) => {
              const reviews = reviewsRes.status === 'fulfilled' && reviewsRes.value && reviewsRes.value.data && Array.isArray(reviewsRes.value.data.data)
                ? reviewsRes.value.data.data
                : []
              const translations = translationsRes.status === 'fulfilled' && translationsRes.value && translationsRes.value.data && Array.isArray(translationsRes.value.data.data)
                ? translationsRes.value.data.data
                : []
              nextCounts.adminReviewQueue = reviews.filter(item => item.status !== 'approved').length
              nextCounts.adminTranslationQueue = translations.filter(item => item.status !== 'completed').length
            })
          )
        }

        if (this.assignedRoles.includes('committee')) {
          tasks.push(
            Service.committeeReview('dashboard').then(response => {
              const data = response && response.data && response.data.data ? response.data.data : {}
              const stats = data && data.stats ? data.stats : {}
              nextCounts.committeeReviewQueue = Number(stats.pending || 0) + Number(stats.inProgress || 0)
            }).catch(() => {})
          )
        }

        if (this.assignedRoles.includes('user') || !this.assignedRoles.length) {
          tasks.push(
            Promise.allSettled([
              Service.agreements('review-queue'),
              Service.userWorkspace('translation-requests', {}, { forceRefresh: !!options.force })
            ]).then(([reviewQueueRes, translationRes]) => {
              const reviewQueue = reviewQueueRes.status === 'fulfilled' && reviewQueueRes.value && reviewQueueRes.value.data && reviewQueueRes.value.data.data
                ? reviewQueueRes.value.data.data
                : {}
              const translations = translationRes.status === 'fulfilled' && translationRes.value && translationRes.value.data && Array.isArray(translationRes.value.data.data)
                ? translationRes.value.data.data
                : []
              nextCounts.userReviewQueue = Array.isArray(reviewQueue.pending) ? reviewQueue.pending.length : 0
              nextCounts.userTranslationQueue = translations.filter(item => item.status !== 'completed').length
            })
          )
        }

        await Promise.allSettled(tasks)
        this.navCounts = nextCounts
        this.lastSidebarCountsAt = Date.now()
      } catch (error) {
        // Keep the sidebar stable even if one of the count sources fails.
      } finally {
        this.countsLoading = false
      }
    }
  }
}
</script>

<style>
.c-sidebar {
  pointer-events: auto;
  position: relative;
  z-index: 1040;
}

.c-sidebar .c-sidebar-nav,
.c-sidebar .c-sidebar-nav-link,
.c-sidebar .c-sidebar-nav-dropdown-toggle,
.c-sidebar .c-sidebar-nav-dropdown-items {
  pointer-events: auto;
}

.bg-style1{
  background: linear-gradient(30deg,#FEC260 0%,#8c1515 60%);
}
</style>
